export class Auth {
    constructor(
        public username: string,
        public password: string
    ){}
}


// WEBPACK FOOTER //
// ./src/holiday/models/Auth.ts